module.exports = __webpack_public_path__ + "img/edit-message.325341e0.png";